import React, { useEffect, useRef, useState, type JSX } from 'react';
import styled from 'styled-components';
import { PageContent } from '@client/style/Shared';
import { ModuleWrapper } from './ModuleWrapper';
import AnimationSceneComponent from '@client/animationv2/AnimationSceneComponent';
import { useSurroundingColors } from '@client/modules/shared/UseSurroundingColors';

const StyledModuleWrapper = styled(ModuleWrapper)`
	position: relative;
	width: 100%;
	margin-top: -1px; /* Remove the 1px line - rounding issue */
`;

const StyledAnimation = styled(AnimationSceneComponent)<{ $baseHeightOnAnimation?: boolean }>`
	position: ${props => (props.$baseHeightOnAnimation ? 'relative' : 'absolute')};
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	pointer-events: none;
`;

const ColorWrapper = styled.div<{ $bg?: string }>`
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: -1;
	background-color: ${props => props.$bg};
	position: absolute;
`;

const TopColor = styled.div<{ $color?: string }>`
	top: 0;
	left: 0;
	width: 100%;
	height: 50%;
	z-index: -1;
	background-color: ${props => props.$color};
	position: absolute;
`;
const BottomColor = styled.div<{ $color?: string }>`
	top: 50%;
	left: 0;
	width: 100%;
	height: 50%;
	z-index: -1;
	background-color: ${props => props.$color};
	position: absolute;
`;

interface IProps {
	className?: string;
	children: JSX.Element | JSX.Element[];
	moduleData: any;
	baseHeightOnAnimation?: boolean;
	usePreloader?: boolean;
	sortingIndex?: number;
}

export const AnimatedModule = (props: IProps) => {
	const [hasMounted, setHasMounted] = useState<boolean>();
	const moduleRef = useRef<HTMLDivElement | null>(null);
	const backgroundColors = useSurroundingColors(moduleRef, [hasMounted]);

	useEffect(() => {
		setHasMounted(true);
	}, []);

	return (
		<StyledModuleWrapper className={props.className} id={props.moduleData.moduleId && props.moduleData.moduleId}>
			<ColorWrapper
				className='colorWrapperAnimatedModule'
				$bg={props.moduleData.backgroundColorLink?.color}
				ref={moduleRef}
			>
				<TopColor $color={backgroundColors[0]}></TopColor>
				<BottomColor $color={backgroundColors[1]}></BottomColor>
			</ColorWrapper>
			<StyledAnimation
				data={props.moduleData.animation}
				$baseHeightOnAnimation={props.baseHeightOnAnimation}
				usePreloader={props.usePreloader ? props.usePreloader : false}
			/>
			<PageContent>{props.children}</PageContent>
		</StyledModuleWrapper>
	);
};
